import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/info.svg
 */
const IconInfo: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M13.5 16.501a1.5 1.5 0 01-2.998 0v-4.499a1.5 1.5 0 112.999 0v4.5zm-1.5-7.5a1.502 1.502 0 01-1.471-1.793 1.5 1.5 0 012.972.293A1.417 1.417 0 0112 9z"
      fill="currentColor"
    />
    <path
      d="M12 24a12 12 0 1112-11.998A12.033 12.033 0 0112 24zm0-22.515a10.517 10.517 0 1010.517 10.517A10.546 10.546 0 0012 1.485z"
      fill="currentColor"
    />
  </svg>
);

export default IconInfo;
